import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d868890"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "routes-menu-comp"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
  class: "menu-title"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  key: 1,
  class: "menu-dot"
};
const _hoisted_6 = {
  class: "menu-title"
};
const __default__ = {
  name: 'routes-menu-comp',
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
import RoutesMenu from './routesMenu';
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      }
    },
    // 菜单层级，用于判断图标的展示，一级路由才展示图标
    level: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.name
        }, [item.isParent ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 0,
          index: item.path
        }, {
          title: _withCtx(() => [_createElementVNode("img", {
            class: "menu-icon",
            src: require(`@/assets/image/menuIcon/${item.icon}.png`),
            alt: item.icon
          }, null, 8, _hoisted_2), _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1)]),
          default: _withCtx(() => [_createVNode(_unref(RoutesMenu), {
            level: __props.level + 1,
            menu: item.children
          }, null, 8, ["level", "menu"])]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: item.path,
          id: item.code || null
        }, {
          title: _withCtx(() => [__props.level === 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "menu-icon",
            src: require(`@/assets/image/menuIcon/${item.icon}.png`),
            alt: item.icon
          }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("span", _hoisted_5)), _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["index", "id"]))], 64);
      }), 128))]);
    };
  }
});